/**
 * @file 微信提示模板
 * @author yanyiting <yanyiting@baidu.com>
 */

const tipsTpl = appName =>
    `<style>
        .openBox-weixinTip {
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 999999;
            min-height: 100%;
            background: #fff;
        }
        .openBox-weixinTip-container {
            width: 100%;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -52%);
        }
        .openBox-weixinTip .title {
            font-family: PingFangSC-Medium;
            font-size: 19px;
            color: #303030;
            text-align: center;
        }
        .openBox-weixinTip .sub-title {
            margin-top: 5px;
            opacity: .52;
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #303030;
            text-align: center;
        }
        .openBox-weixinTip .more-icon {
            width: 107px;
            height: 107px;
            margin: 64px auto 0;
            background: url(https://b.bdstatic.com/searchbox/icms/searchbox/img/super-fe/gem-h5/more-icon.png) center / contain no-repeat;
        }
        .openBox-weixinTip .small-text {
            margin-top: 10px;
            opacity: .52;
            font-family: PingFangSC-Regular;
            font-size: 15px;
            color: #303030;
            text-align: center;
        }
        .openBox-weixinTip .safari-icon {
            width: 107px;
            height: 107px;
            margin: 60px auto 0;
            background: url(https://b.bdstatic.com/searchbox/icms/searchbox/img/super-fe/gem-h5/safari-icon.png) center / contain no-repeat;
        }
    </style>
    <div class="openBox-weixinTip">
        <div class="openBox-weixinTip-container">
            <div class="title">请按照下面的示意图操作</div>
            <div class="sub-title">打开${appName} APP</div>
            <div class="more-icon"></div>
            <div class="small-text">点击右上角</div>
            <div class="safari-icon"></div>
            <div class="small-text">点击打开浏览器</div>
        </div>
    </div>`;

/**
 * 展示微信tips
 *
 * @param {string} appName App名称
 */
export default appName => {
    let tip;
    let html;
    if (!tip) {
        html = document.getElementsByTagName('html')[0];
        tip = document.createElement('div');
    }
    tip.innerHTML = tipsTpl(appName);
    document.body.appendChild(tip);
    html && (html.style.overflow = 'hidden');
};
